import { useGet } from '../../../sharedModules/hooks/useQuery';
import { CollectionEmailSendsResponse } from '../model';

export interface EmailSendsQueryParams {
  location: string;
  page?: number;
  per_page?: number;
  status?: string;
  tone?: string;
  send_source?: string;
  company?: string;
  bill_code?: string;
  collections_client_id?: number;
}

export function useCollectionEmailSends(params: EmailSendsQueryParams, enabled = true) {
  return useGet<CollectionEmailSendsResponse>({
    url: '/collections/email_sends',
    params: params as unknown as Record<string, unknown>,
    enabled: !!params.location && enabled,
  });
}
